import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { NoveltiesContainer } from 'src/features/novelties/NoveltiesContainer';
import { PageLayout } from 'src/layouts/PageLayout';

export function NoveltiesDefaultPage(): ReactElement {
  const { t } = useTranslation('novelties');

  return (
    <PageLayout title={t('novelties')}>
      <NoveltiesContainer />
    </PageLayout>
  );
}
